// extracted by mini-css-extract-plugin
export default {"card":"broker-account-card_card__PzVQa","cardContent":"broker-account-card_cardContent__6jltU"};